/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Response filter metadata for the tool
 */
export type ResponseFilter = {
  /**
   * Content types to filter for
   */
  contentTypes: Array<string>;
  /**
   * Status codes to filter for
   */
  statusCodes: Array<string>;
  /**
   * Response filter type for the tool
   */
  type: string;
};

/** @internal */
export const ResponseFilter$inboundSchema: z.ZodMiniType<
  ResponseFilter,
  unknown
> = z.pipe(
  z.object({
    content_types: z.array(z.string()),
    status_codes: z.array(z.string()),
    type: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "content_types": "contentTypes",
      "status_codes": "statusCodes",
    });
  }),
);

export function responseFilterFromJSON(
  jsonString: string,
): SafeParseResult<ResponseFilter, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseFilter$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseFilter' from JSON`,
  );
}
